
import { errManager, showNotification } from '@/core/config/Tools';
import { defineComponent, ref } from 'vue';
import { useI18n } from "vue-i18n/index";
import formService from "@/core/services/FormService"
//forms
import Form1 from "../pages/FormsFisu/GeneralEntryForm.vue";
import Form2 from "../pages/FormsFisu/QuantitativeForm.vue"
import CountDown from "@/components/widgets/mixed/dsCounter.vue"

export default defineComponent({
    props: {
        idEvent: {
            type: null,
            required: true
        },
        itemForm: {
            type: Object,
            required: false
        }
    },
    components: { Form1, Form2, CountDown },
    setup(props, { emit, expose }) {
        const { t } = useI18n();
        const isDrawerOpen = ref(false);
        const formExpired = ref<Boolean>(false);
        const childComponentRef = ref<any>(null);
        const isFormLoaded = ref(false);
        const loading = ref(false);
        const idForm = ref(0)

        const openDrawer = () => {
            isDrawerOpen.value = true;
        };

        const onOpened = () => {
            idForm.value = props.itemForm?.idform
        };

        const onClosed = () => {
            idForm.value = 0;
            isFormLoaded.value = false
            formExpired.value = false
            emit('modalClosed')
        }

        const onFormLoaded = () => {
            isFormLoaded.value = true;
        };

        const saveAsDraf = () => {
            save(4)
        };

        const saveAndSend = async () => {
            if (childComponentRef.value) {
                await childComponentRef.value.formQRef.validate((valid: boolean) => {
                    if (valid)
                        save(3)
                    else {
                        showNotification({
                            title: 'Campos vacíos', 
                            message: 'Complete los campos que son obligatorios', 
                            status: 'error'
                        });
                        
                        /*if (scrollbarRef)
                            scrollbarRef.value?.scrollTo({ top: 120, behavior: 'smooth' });
                        */
                    }
                })

            }
        };

        const save = async (method) => {
            loading.value = true
            childComponentRef.value.formQ.save = method;
            await formService.saveForm(`${childComponentRef.value.formQ.idform}/save`, childComponentRef.value.formQ)
                .then((res) => {
                    loading.value = false
                    if (res.data.status == 'success')
                        isDrawerOpen.value = false
                    
                    showNotification(res.data);
                }).catch(({ response }) => {
                    loading.value = false
                    errManager(response)
                }).finally(()=>{
                    loading.value = false;
                })
        };

        const changeStatus = (data: any) => {
            formExpired.value = data
        }

        // expone el método al padre
        expose({
            openDrawer
        });


        return {
            t,
            isDrawerOpen,
            formExpired,
            childComponentRef,
            loading,
            isFormLoaded,
            idForm,

            //events
            onOpened,
            openDrawer,
            saveAsDraf,
            saveAndSend,
            onFormLoaded,
            onClosed,
            changeStatus
        }
        
    },
})
